import { render, staticRenderFns } from "./AIAssistanceButton.vue?vue&type=template&id=629fbcd2&scoped=true&"
import script from "./AIAssistanceButton.vue?vue&type=script&lang=js&"
export * from "./AIAssistanceButton.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistanceButton.vue?vue&type=style&index=0&id=629fbcd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629fbcd2",
  null
  
)

export default component.exports